{
    "es-5404": {
        "disabled": true,
        "variants": {
            "true": true,
            "false": false
        },
        "defaultVariant": "false"
    },
    "es-4621": {
        "disabled": false,
        "variants": {
            "true": true,
            "false": false
        },
        "defaultVariant": "true"
    },
    "es-6024": {
        "disabled": false,
        "variants": {
            "true": true,
            "false": false
        },
        "defaultVariant": "true"
    },
    "es-6024-global": {
        "disabled": false,
        "variants": {
            "true": true,
            "false": false
        },
        "defaultVariant": "true"
    },
    "es-5386-reservation": {
        "disabled": false,
        "variants": {
            "true": true,
            "false": false
        },
        "defaultVariant": "true"
    },
    "es-5404-counter": {
        "disabled": true,
        "variants": {
            "true": true,
            "false": false
        },
        "defaultVariant": "false"
    },
    "bt-dev-debug": {
        "disabled": true,
        "variants": {
            "true": true,
            "false": false
        },
        "defaultVariant": "false"
    },
    "bt-internal-test": {
        "disabled": true,
        "variants": {
            "true": true,
            "false": false
        },
        "defaultVariant": "false"
    },
    "es-6966_paypal": {
        "disabled": false,
        "variants": {
            "true": {
                "enabled": true
            },
            "false": {
                "enabled": false
            }
        },
        "defaultVariant": "true"
    },
    "es-6966_klarna": {
        "disabled": false,
        "variants": {
            "true": {
                "enabled": true
            },
            "false": {
                "enabled": false
            }
        },
        "defaultVariant": "true"
    },
    "es-6717-advisor": {
        "disabled": true,
        "variants": {
            "true": true,
            "false": false
        },
        "defaultVariant": "false"
    },
    "exsi-811": {
        "disabled": false,
        "variants": {
            "true": true,
            "false": false
        },
        "defaultVariant": "false"
    },
    "es-6414-autocomplete": {
        "disabled": false,
        "variants": {
            "true": true,
            "false": false
        },
        "defaultVariant": "true"
    },
    "cfg-preselected-payment-provider": {
        "disabled": false,
        "variants": {
            "paypal": {
                "enabled": true,
                "provider": "paypal"
            },
            "klarnaInstallment": {
                "enabled": true,
                "provider": "klarnaInstallment"
            },
            "payment-proxy": {
                "enabled": true,
                "provider": "payment-proxy"
            }
        },
        "defaultVariant": "klarnaInstallment"
    },
    "cfg-disable-paypal-express-articles": {
        "disabled": true,
        "variants": {
            "true": {
                "articleIds": [
                    "e_12345"
                ]
            },
            "false": {
                "articleIds": []
            }
        },
        "defaultVariant": "false"
    },
    "cfg-clicktracking": {
        "disabled": false,
        "variants": {
            "true": true,
            "false": false
        },
        "defaultVariant": "true"
    },
    "cfg-linktracking": {
        "disabled": true,
        "variants": {
            "true": true,
            "false": false
        },
        "defaultVariant": "false"
    },
    "cfg-seasonal-theme": {
        "disabled": false,
        "variants": {
            "blackweek": {
                "name": "blackweek",
                "bg": "bg-black text-white",
                "logo": "white"
            },
            "christmas": {
                "name": "christmas",
                "bg": "bg-green",
                "logo": "white"
            },
            "none": {
                "name": "default",
                "bg": "bg-white",
                "logo": "default"
            }
        },
        "targeting": {
            "if": [
                {
                    "in": [
                        "staging.brntgs.expert.de",
                        {
                            "var": "site"
                        }
                    ]
                },
                "christmas",
                "none"
            ]
        },
        "defaultVariant": "none"
    },
    "cfg-campaign-parameters": {
        "disabled": false,
        "variants": {
            "true": {
                "parameters": [
                    "campaign",
                    "utm_source",
                    "utm_medium",
                    "gad_campaignid",
                    "gad_source",
                    "adword",
                    "exp_campaign",
                    "scrid",
                    "sgtm_debug"
                ]
            },
            "false": {
                "parameters": []
            }
        },
        "defaultVariant": "true"
    },
    "render-cfg-promo-pill-theme": {
        "disabled": false,
        "variants": {
            "expert-outline": {
                "classes": "font-medium bg-white text-primary border border-primary"
            },
            "expert-solid": {
                "classes": "font-semibold bg-primary text-white border border-primary"
            },
            "exhibit-ausstellungsstück": {
                "classes": "font-semibold bg-[#234F9D] text-white border border-[#234F9D]"
            },
            "exhibit-vorführgerät": {
                "classes": "font-semibold bg-[#94C01F] text-white border border-[#94C01F]"
            },
            "exhibit-b-ware": {
                "classes": "font-semibold bg-[#E5232D] text-white border border-[#E5232D]"
            },
            "exhibit-kundenrückläufer": {
                "classes": "font-semibold bg-[#52AC38] text-white border border-[#52AC38]"
            },
            "exhibit-restposten": {
                "classes": "font-semibold bg-[#EE7200] text-white border border-[#EE7200]"
            },
            "exhibit-aussteller": {
                "classes": "font-semibold bg-[#7e7e7e] text-white border border-[#7e7e7e]"
            },
            "exhibit-default": {
                "classes": "font-semibold bg-[#7e7e7e] text-white border border-[#7e7e7e]"
            },
            "blueberry-outline": {
                "classes": "font-semibold bg-white text-blue-700 border border-blue-600"
            },
            "blueberry-solid": {
                "classes": "font-semibold bg-blue-600 text-white border border-blue-700"
            },
            "matcha-outline": {
                "classes": "font-semibold bg-white text-green-700 border border-green-600"
            },
            "matcha-solid": {
                "classes": "font-semibold bg-green-600 text-white border border-green-700"
            },
            "mango-outline": {
                "classes": "font-bold bg-white text-orange-700 border border-orange-600"
            },
            "mango-solid": {
                "classes": "font-bold bg-orange-500 text-white border border-orange-600"
            },
            "cherry-outline": {
                "classes": "font-bold bg-white text-red-700 border border-red-600"
            },
            "cherry-solid": {
                "classes": "font-bold bg-red-600 text-white border border-red-700"
            },
            "platinum-outline": {
                "classes": "font-semibold bg-white text-slate-800 border border-slate-400"
            },
            "platinum-solid": {
                "classes": "font-semibold bg-slate-700 text-white border border-slate-800"
            },
            "violet-outline": {
                "classes": "font-semibold bg-white text-violet-700 border border-violet-600"
            },
            "violet-solid": {
                "classes": "font-semibold bg-violet-600 text-white border border-violet-700"
            },
            "ice-outline": {
                "classes": "font-semibold bg-white text-cyan-800 border border-cyan-600"
            },
            "ice-solid": {
                "classes": "font-semibold bg-cyan-600 text-white border border-cyan-700"
            },
            "blackweek-outline": {
                "classes": "font-extrabold bg-white text-black border border-black"
            },
            "blackweek-solid": {
                "classes": "font-extrabold bg-black text-white border border-black"
            },
            "christmas-outline": {
                "classes": "font-bold bg-white text-red-700 border border-red-600"
            },
            "christmas-solid": {
                "classes": "font-bold bg-red-600 text-white border border-red-700"
            },
            "paypal": {
                "classes": "font-bold bg-[#ffc43b] text-[#003287] border border-[#003287]"
            },
            "klarna": {
                "classes": "font-bold bg-[#ffa8ce] text-black border border-black"
            },
            "payback-solid": {
                "classes": "font-bold bg-[#cce6ff] text-[#003EB0] border border-[#003EB0]"
            }
        },
        "defaultVariant": "expert-outline"
    },
    "exs-239": {
        "disabled": false,
        "variants": {
            "true": {
                "banners": [
                    {
                        "title": "Apple Konfigurator",
                        "alt": "Apple Konfigurator",
                        "description": "",
                        "link": "/searchlandingpage/MacBook-Konfigurator",
                        "mobileImage": "2f/7a/91/5a9be72dcdc89c9c97b1decccffd59b9b6/AppleMacBookKonfigurator.jpg",
                        "desktopImage": "2f/7a/91/5a9be72dcdc89c9c97b1decccffd59b9b6/AppleMacBookKonfigurator.jpg",
                        "priority": 0,
                        "articleIds": [
                            "e_832863",
                            "e_907931",
                            "e_832865",
                            "e_894365",
                            "e_915665",
                            "e_915680",
                            "e_894363",
                            "e_869578",
                            "e_869581",
                            "e_832866",
                            "e_869595",
                            "e_907917",
                            "e_907925"
                        ],
                        "position": "PDS_LEFT"
                    }
                ]
            },
            "false": {
                "banners": []
            }
        },
        "defaultVariant": "false"
    },
    "exsi-443": {
        "disabled": false,
        "variants": {
            "A": "A",
            "B": "B",
            "C": "C"
        },
        "targeting": {
            "if": [
                {
                    "==": [
                        {
                            "var": "campaigns"
                        },
                        "exp_campaign=var_a"
                    ]
                },
                "A",
                {
                    "if": [
                        {
                            "==": [
                                {
                                    "var": "campaigns"
                                },
                                "exp_campaign=var_b"
                            ]
                        },
                        "B",
                        {
                            "if": [
                                {
                                    "==": [
                                        {
                                            "var": "campaigns"
                                        },
                                        "exp_campaign=var_c"
                                    ]
                                },
                                "C",
                                "B"
                            ]
                        }
                    ]
                }
            ]
        },
        "defaultVariant": "B"
    },
    "exsi-1263": {
        "disabled": false,
        "variants": {
            "on": {
                "enabled": true,
                "expId": "8",
                "filterOfferType": "trade-in"
            },
            "off": {
                "enabled": false,
                "expId": "-1"
            }
        },
        "defaultVariant": "on"
    },
    "exsi-1521_include_to_shoppingcart_button": {
        "disabled": false,
        "variants": {
            "true": {
                "enabled": true
            },
            "false": {
                "enabled": false
            }
        },
        "defaultVariant": "false"
    },
    "exsi-1556": {
        "state": "ENABLED",
        "variants": {
            "none": {
                "name": "none"
            },
            "basic": {
                "name": "basic"
            },
            "full": {
                "name": "full"
            }
        },
        "targeting": {
            "if": [
                {
                    "in": [
                        "exp_campaign=basic",
                        {
                            "var": "campaigns"
                        }
                    ]
                },
                "basic",
                {
                    "if": [
                        {
                            "in": [
                                "exp_campaign=full",
                                {
                                    "var": "campaigns"
                                }
                            ]
                        },
                        "full",
                        {
                            "if": [
                                {
                                    "in": [
                                        {
                                            "var": "usergroup"
                                        },
                                        [
                                            "expzentrale",
                                            "payback-basic",
                                            "internal"
                                        ]
                                    ]
                                },
                                "basic",
                                "basic"
                            ]
                        }
                    ]
                }
            ]
        },
        "defaultVariant": "basic"
    },
    "exsi-1610_reseller_protection": {
        "state": "ENABLED",
        "variants": {
            "true": true,
            "false": false
        },
        "defaultVariant": "true"
    },
    "exsi-1603-payback": {
        "disabled": false,
        "variants": {
            "true": true,
            "false": false
        },        
        "defaultVariant": "true"
    },
    "cfg-article-showonlineservices": {
        "disabled": false,
        "variants": {
            "true": {
                "companygroupids": [
                    "0"
                ]
            },
            "false": {
                "companygroupids": [
                    "0"
                ]
            }
        },
        "defaultVariant": "true"
    },
    "cfg-store-service-priority-order": {
        "disabled": false,
        "variants": {
            "default": {
                "priorityIds": [
                    "1",
                    "5"
                ]
            },
            "custom": {
                "priorityIds": []
            }
        },
        "defaultVariant": "default"
    },
    "exsi-1765": {
        "disabled": false,
        "variants": {
            "true": true,
            "false": false
        },
        "defaultVariant": "false"
    }
}